import { render } from "./side-list-item.vue?vue&type=template&id=c75ee2f6&scoped=true&ts=true"
import script from "./side-list-item.vue?vue&type=script&lang=ts"
export * from "./side-list-item.vue?vue&type=script&lang=ts"

import "./side-list-item.vue?vue&type=style&index=0&id=c75ee2f6&lang=scss&scoped=true"

import exportComponent from "D:\\project\\newb\\bnet2.0\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c75ee2f6"]])

export default __exports__